module.exports = __webpack_public_path__ + "img/logoColorizedWhite.3ca7c557.png";